"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
const expressions_1 = require("@mwater/expressions");
const react_linkify_1 = __importDefault(require("react-linkify"));
const valueFormatter_1 = require("../valueFormatter");
const valueFormatter_2 = require("../valueFormatter");
// Cell that displays an expression column cell
class ExprCellComponent extends react_1.default.Component {
    renderImage(id) {
        const url = this.props.dataSource.getImageUrl(id);
        return react_1.default.createElement("a", { href: url, key: id, target: "_blank", style: { paddingLeft: 5, paddingRight: 5 } }, T `Image`);
    }
    renderCellContent() {
        let { value } = this.props;
        const exprUtils = new expressions_1.ExprUtils(this.props.schema);
        if (value == null || !this.props.expr) {
            return null;
        }
        else {
            // Parse if should be JSON
            if (["image", "imagelist", "geometry", "text[]"].includes(this.props.exprType) && lodash_1.default.isString(value)) {
                try {
                    value = JSON.parse(value);
                }
                catch (e) {
                    console.error("Error parsing JSON", e);
                    return "???";
                }
            }
            // Format if possible
            if ((0, valueFormatter_1.canFormatType)(this.props.exprType)) {
                return (0, valueFormatter_2.formatValue)(this.props.exprType, value, this.props.format);
            }
            else {
                // Convert to node based on type
                switch (this.props.exprType) {
                    case "text":
                        return react_1.default.createElement(react_linkify_1.default, { properties: { target: "_blank" } }, value);
                    case "boolean":
                    case "enum":
                    case "enumset":
                    case "text[]":
                        return exprUtils.stringifyExprLiteral(this.props.expr, value, this.props.locale);
                    case "date":
                        return (0, moment_1.default)(value, "YYYY-MM-DD").format("ll");
                    case "datetime":
                        return (0, moment_1.default)(value, moment_1.default.ISO_8601).format("lll");
                    case "image":
                        return this.renderImage(value.id);
                    case "imagelist":
                        return lodash_1.default.map(value, (v) => this.renderImage(v.id));
                    default:
                        return "" + value;
                }
            }
        }
    }
    render() {
        const content = this.renderCellContent();
        return (react_1.default.createElement("div", { style: {
                width: this.props.width,
                height: this.props.height,
                whiteSpace: "nowrap",
                textAlign: ["number"].includes(this.props.exprType) ? "right" : "left",
                opacity: this.props.muted ? 0.4 : undefined,
                padding: 8,
                cursor: this.props.onClick ? "pointer" : undefined,
                overflow: "hidden",
                textOverflow: "ellipsis"
            }, onClick: this.props.onClick, onDoubleClick: this.props.onDoubleClick }, content));
    }
}
exports.default = ExprCellComponent;
